import { APPLICATION_TYPES } from 'src/app/model/constants/application-types';
import { IDegree } from '../model/degree/idegree';

export class PaymentCalculator {

    constructor(private applicationType: string) { }

    public calulate(value?: IDegree) {
        if (this.applicationType === APPLICATION_TYPES.SUPPLEMENT_SWEDISH) {
            return 990;
        }
        const first = value && value.firstExamina ? value.firstExamina.year : null;
        const second = value && value.secondExamina ? value.firstExamina.year : null;
        return this.shouldPay(first, second) ? 1890 : 0;
    }

    private shouldPay(first: string, second: string): boolean {
        const year = this.smallest(first, second);
        return Boolean(first) && year > 2010;
    }

    private smallest(first: string, second: string): number {
        const arr = [first, second]
            .filter((value) => value !== null)
            .map((value) => Number(value));
        return Math.min.apply(null, arr);
    }
}
